'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diffusionConnector;

var _wildemitter = require('wildemitter');

var _wildemitter2 = _interopRequireDefault(_wildemitter);

var _topicStore = require('./topicStore');

var _topicStore2 = _interopRequireDefault(_topicStore);

var _cachedValue = require('../utils/cachedValue');

var _idleTimer = require('./idleTimer');

var _idleTimer2 = _interopRequireDefault(_idleTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connector(state) {
    var emitter = state.emitter;
    var provider = state.provider;

    var currentSession = void 0;
    var topicStore = (0, _topicStore2.default)();
    var createEmit = function createEmit(eventName) {
        return emitter.emit.bind(emitter, eventName);
    };
    var onConnected = createEmit('connected');
    var onConnectionError = createEmit('connectionError');
    var sessionSubscriptions = {
        disconnect: createEmit('disconnect'),
        error: createEmit('error'),
        reconnect: createEmit('reconnect'),
        close: createEmit('close')
    };

    function closeSession() {
        if (currentSession) {
            currentSession.close();
        }
    }

    function clearTopicStoreSession() {
        topicStore.setSession(null);
    }

    function setProvider(newProvider) {
        provider = newProvider;
        closeSession();
    }

    function updateSession(session) {
        session.on(sessionSubscriptions);
        topicStore.setSession(session);
        currentSession = session;
        return currentSession;
    }

    var _singleValueCache = (0, _cachedValue.singleValue)(function () {
        return (
            // JP-10398
            // if (!shouldEstablishSession()) {
            //     return null;
            // }

            provider().then(updateSession).then(onConnected).catch(onConnectionError)
        );
    }),
        connect = _singleValueCache.getValue,
        resetConnected = _singleValueCache.reset;

    emitter.on('close', function () {
        currentSession.off(sessionSubscriptions);
        resetConnected();

        if (_idleTimer2.default.isEnabled && _idleTimer2.default.isSubscribed || !_idleTimer2.default.isEnabled) {
            connect();
        }

        // JP-10398
        // if (shouldEstablishSession()) {
        //     connect();
        // }
    });

    var subscribe = function subscribe(topics) {
        // JP-10398
        // if (!shouldEstablishSession()) {
        //     return [];
        // }

        connect();
        return topicStore.subscribe(topics);
    };

    return {

        /**
         *
         * @deprecated
         * @param {any} topic
         * @returns
         */
        connect: connect,

        /**
         * This function is called from DiffusionService
         * @param {String} topic
         * @return {Subscription}
         * @memberOf DiffusionConnector
         */
        subscribe: subscribe,

        setProvider: setProvider,

        closeSession: closeSession,

        clearTopicStoreSession: clearTopicStoreSession
    };
}

/**
 * Wrapper upon the [Diffusion Unified Library]{@link https://www.npmjs.com/package/diffusion}
 * [API DOC 5.7.5]{@link http://docs.pushtechnology.com/docs/5.7.5/js/index.html}
 * [USER MANUAL 5.7.5]{@link http://docs.pushtechnology.com/docs/5.7.5/manual/html/developerguide/apis/javascript/using.html}
 * @class DiffusionConnector
 * @extends {Emitter}
 */
function diffusionConnector(provider) {
    var emitter = new _wildemitter2.default();
    var state = {
        emitter: emitter,
        provider: provider
    };
    return Object.assign(emitter, connector(state));
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/diffusionConnector.js
// module id = 1764
// module chunks = 1